export class Document {
  id: string;
  name: string;
  path: string;
  parentID: string;
  parentType: string;
  parentPath: string;
  tokenPath: string;
  markAsReview?:boolean;
reviewRequired?:boolean;
reviewedBy?:string;
reviewedOn?:string;
documentName?:string;
  metaData: { [key: string]: string };
workflowAplicationId?:string
  constructor(options?: Partial<Document>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
